module.exports = __webpack_public_path__ + "static/media/scio.94d92f26.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/scio.png
// module id = 438
// module chunks = 0